// This icon file is generated automatically.
var PRotateLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.5 5.53H1.25a.5.5 0 00-.5.5v6.47c0 .28.22.5.5.5H9.5a.5.5 0 00.5-.5V6.03a.5.5 0 00-.5-.5zm-.69 6.28H1.94v-5.1H8.8v5.1zm3-7.68a6.27 6.27 0 00-4.92-2.4v-1c0-.1-.13-.16-.2-.1l-2 1.58a.12.12 0 000 .19l2 1.58c.08.06.2 0 .2-.1v-1a5.26 5.26 0 012.46.65 5.11 5.11 0 012.55 5.33h1.17a6.23 6.23 0 00-1.27-4.73z", "fill-rule": "nonzero" } }] }, "name": "p-rotate-left", "theme": "outlined" };
export default PRotateLeftOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PRotateLeftOutlined.js
// module id = 3611
// module chunks = 0